import React, { useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
  getKeyValue,
} from "@nextui-org/react";
import { LoaderCustom } from "../../components";
import { useGetMachineOfStoreApi } from "../../hooks";
import { Tag } from "antd";

export default function MachineOfStore() {
  // state
  const [page, setPage] = useState(1);
  const [isLoader, setIsLoader] = useState(false);
  const [machine, setMachine] = useState<any>([]);

  // api get store
  const { machineOfStore, isLoading } = useGetMachineOfStoreApi();

  const rowsPerPage = 10;

  const pages = Math.ceil(machine.length / rowsPerPage);

  // useEffect for loader
  useEffect(() => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, 200);
  }, []);

  // useEffect for get data
  useEffect(() => {
    if (machineOfStore?.data?.length > 0) {
      const storeConvert = machineOfStore?.data?.map((item: any) => {
        return {
          userId: item?.userId,
          userName: item?.userName,
          pgmType: item?.pgmType,
          password: item?.password,
          printPaper: item?.printPaper,
        };
      });
      setMachine(storeConvert);
    }
  }, [machineOfStore, isLoading]);

  const items = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;

    return machine.slice(start, end);
  }, [page, machine]);

  return (
    <>
      {isLoader && <LoaderCustom></LoaderCustom>}
      <div className="md:mt-4">
        <Table
          aria-label="Example table with client side pagination"
          bottomContent={
            <div className="flex w-full justify-center">
              <Pagination
                isCompact
                showControls
                showShadow
                color="default"
                page={page}
                total={pages}
                onChange={(page) => setPage(page)}
              />
            </div>
          }
          classNames={{
            wrapper: "min-h-[32vh]",
            th: "text-center",
            td: "text-center",
          }}
        >
          <TableHeader>
            <TableColumn key="userId">MACHINE ID</TableColumn>
            <TableColumn key="userName">NAME</TableColumn>
            <TableColumn key="pgmType">TYPE</TableColumn>
            <TableColumn key="password">PASSWORD</TableColumn>
            <TableColumn key="printPaper">PRINTER PAPER</TableColumn>
          </TableHeader>
          <TableBody items={items}>
            {(item: any) => (
              <TableRow key={item.userId}>
                {(columnKey) => {
                  if (columnKey === "pgmType") {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        <Tag color="cyan">
                          {getKeyValue(item, columnKey) === "PRM"
                            ? "Premium"
                            : "Standard"}
                        </Tag>
                      </TableCell>
                    );
                  } else {
                    return (
                      <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                        {getKeyValue(item, columnKey)}
                      </TableCell>
                    );
                  }
                }}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </>
  );
}
